import SVGIconWrapper from "./SVGIconWrapper"

const IconEdit = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "none"}
        style={props.style}
        viewBox="0 0 24 24"
        iconClass={`icon--edit ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M18 10L21 7L17 3L14 6M18 10L8 20H4V16L14 6M18 10L14 6" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </SVGIconWrapper>
)

export default IconEdit